<template>
  <original-form
    ref="form"
    label-position="top"
    @submit.prevent.native="onSubmit"
    :rules="rules"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <!-- @slot Contenu du formulaire -->
    <slot></slot>
  </original-form>
</template>

<script>
import { Form } from 'element-ui'

/**
 * Formulaire avec validation automatique.
 *
 * Basé principalement sur le [formulaire Element](https://element.eleme.io/#/fr-FR/component/form)
 * @link https://element.eleme.io/#/fr-FR/component/form
 */
export default {
  name: 'ElForm',
  components: {
    OriginalForm: Form
  },
  props: {
    /**
     * Règles de validation
     *
     */
    rules: Object
  },
  methods: {
    validate (callback) {
      return this.$refs.form.validate(callback)
    },
    validateField (field, callback) {
      return this.$refs.form.validateField(field, callback)
    },
    /**
     * Alias pour la méthode resetFields
     * @public
     */
    reset () {
      return this.$refs.form.resetFields()
    },
    resetFields () {
      return this.$refs.form.resetFields()
    },
    /**
     * Alias pour la méthode clearValidate
     * @type {param} fields
     * @public
     */
    clear (fields) {
      return this.$refs.form.clearValidate(fields)
    },
    clearValidate (fields) {
      return this.$refs.form.clearValidate(fields)
    },
    onSubmit () {
      if (!this.rules) {
        return this.$emit('submit-valid')
      }
      this.$refs.form.validate((valid, errors) => {
        if (!valid) {
          /**
           * À la soumission du formulaire, s'il y a une erreur.
           * @event submit-error
           * @type {array}
           */
          return this.$emit('submit-error', errors)
        }
        /**
         * À la soumission du formulaire, si tout est valide ou s'il n'y a pas de règle définie.
         * @event submit-valid
         * @type {void}
         */
        return this.$emit('submit-valid')
      })
    }
  }
}
</script>

<docs>
### Exemple

```html
<template>
  <el-form
    :rules="myRules"
    :model="myModel"
    @submit-valid="onSubmit"
    @submit-error="onError"
  >
    ...
    <el-button native-type="submit">Envoyer</el-button>
  </el-form>
</template>
```

</docs>
